import React, { Component } from "react";
import { Button, Form, Input, Modal, Row } from "antd";
import CloseIcon from "../../../assets/fi_x-circle.svg";
import { injectIntl } from "react-intl";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { setkeyboardEnabled } from "../../../actions/AppAction";
import { sendShareAssets } from "../../../actions/AssetsShareAction";
import { editFolder } from "../../../actions/ClientAction";
import { cleanDataBackRoot, getRoot } from "../../../actions/AssetsRootAction";
import { getExplore } from "../../../actions/AssetsExploreAction";
import { getLastUploads } from "../../../actions/AssetsLastUploadAction";
import { getFavorites } from "../../../actions/AssetsFavoritesAction";
import { getShared } from "../../../actions/AssetsShareAction";
import { getNewPermission, sendNotification } from "../../../utils/index";
import "./TagProtocolModal.css";

class TagProtocolModal extends Component {
  constructor(props) {
    super(props);
    const regex = /(<([^>]+)>)/gi;
    const htmlEntities = /&#{0,1}[a-z0-9]+;/gi;
    const result =
      props.selectedFile && props.selectedFile.tagProtocol
        ? props.selectedFile.tagProtocol
            .replace(regex, "")
            .replace(htmlEntities, "")
        : "";
    this.state = {
      newTagProtocol: props.selectedFile.tagProtocol || "",
      tagProtocolLength: result.trim().length
    };
  }

  componentDidMount() {
    this.props.setkeyboardEnabled(true);
  }

  handleOnInputChange = e => {
    const regex = /(<([^>]+)>)/gi;
    const htmlEntities = /&#{0,1}[a-z0-9]+;/gi;
    const result =
      e.target.value && e.target.value !== ""
        ? e.target.value.replace(regex, "").replace(htmlEntities, "")
        : "";
    this.setState({
      newTagProtocol: e.target.value,
      tagProtocolLength: result.trim().length
    });
  };

  handleOnEdit = () => {
    const { workclient, selectedFile, user, newMatrix, intl } = this.props;

    const { newTagProtocol } = this.state;

    const canEditFolder =
      user.clientRole !== "admin" && user.role !== "admin"
        ? getNewPermission(selectedFile._id, newMatrix, "editFolder")
        : true;

    if (!canEditFolder) {
      sendNotification(
        "warning",
        intl,
        intl.formatMessage({ id: "permission_denied" })
      );
      return;
    }
    if (newTagProtocol.length === 0) {
      sendNotification(
        "warning",
        intl,
        intl.formatMessage({ id: "tag-prot-modal-empty" })
      );
      return;
    }

    this.props.editFolder(
      workclient,
      selectedFile._id,
      selectedFile.name,
      null,
      null,
      undefined,
      newTagProtocol,
      this.handleOnHideModal
    );
  };

  handleOnHideModal = () => {
    const { intl, workclient, root, limit, keyCollection } = this.props;
    sendNotification(
      "success",
      intl,
      intl.formatMessage({ id: "tag-prot-modal-success" })
    );
    const location = this.props.history.location.pathname;
    if (!location.includes("explore")) {
      if (keyCollection === "assetsLastUploads") {
        this.props.getLastUploads(workclient, root);
      } else if (keyCollection === "assetsShared") {
        this.props.getShared(workclient, root);
      } else if (keyCollection === "assetsFavorites") {
        this.props.getFavorites(workclient, root);
      } else {
        this.props.cleanDataBackRoot();
        // this.props.getRoot(workclient, root)
        this.props.getRoot(workclient, root, true, [], 1, 40);
      }
      this.props.handleHiddenModal();
      return;
    }
    const folderId = location.split("/").pop();
    if (!folderId) return;
    this.props.handleHiddenModal();
    if (keyCollection === "assetsLastUploads") {
      this.props.getLastUploads(workclient, folderId, 1, null, true, [], limit);
    } else if (keyCollection === "assetsShared") {
      this.props.getShared(workclient, folderId, 1, null, true, [], limit);
    } else if (keyCollection === "assetsFavorites") {
      this.props.getFavorites(workclient, folderId, 1, null, true, [], limit);
    } else {
      this.props.getExplore(workclient, folderId, 1, null, true, [], 40);
    }
  };

  render() {
    const {
      showModal,
      handleHiddenModal,
      intl,
      selectedFile,
      isInFolderAction
    } = this.props;

    const { newTagProtocol, tagProtocolLength } = this.state;
    return (
      <Modal
        visible={showModal}
        onCancel={handleHiddenModal}
        width={500}
        footer={null}
        centered
        closeIcon={<img src={CloseIcon} alt={"icon close"} />}
        className="tag-prot-modal"
      >
        <div className="tag-prot-modal-title">
          {intl.formatMessage({ id: "tag-prot-modal-title" })}
        </div>

        <Form>
          <p className="tag-prot-modal-label">
            {intl.formatMessage({ id: "tag-prot-modal-label1" })}
          </p>
          <Input
            placeholder={intl.formatMessage({ id: "tag-prot-modal-input1" })}
            value={selectedFile.name}
            className="tag-prot-modal-input rename-folder"
            contentEditable={false}
            disabled
          />
          <br />
          <p className="tag-prot-modal-label">
            {intl.formatMessage({ id: "tag-prot-modal-title" })}
          </p>
          <Input.TextArea
            placeholder={intl.formatMessage({ id: "tag-prot-modal-input2" })}
            value={newTagProtocol}
            onChange={this.handleOnInputChange}
            rows={6}
            className="tag-prot-modal-area"
            maxLength={150}
          />
          <p className="tag-prot-modal-counter">{`${tagProtocolLength}/150`}</p>
        </Form>

        <Row type={"flex"} justify={"space-between"}>
          <Button
            size={"large"}
            type={"primary"}
            onClick={this.handleOnEdit}
            loading={isInFolderAction}
            className="tag-prot-modal-button accept"
          >
            {intl.formatMessage({ id: "edit_asset" })}
          </Button>
          <Button
            size={"large"}
            type={"primary"}
            ghost
            onClick={handleHiddenModal}
            className="tag-prot-modal-button cancel"
          >
            {intl.formatMessage({ id: "cancel_button" })}
          </Button>
        </Row>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  return {
    selectedFile: state.individualSelect.selectedFile,
    workclient: state.client.workclient,
    isInFolderAction: state.client.isInFolderAction,
    user: state.authUser.user,
    newMatrix: state.group.newMatrix,
    root: state.client.root,
    limit: state.assetsExplore.limit,
    keyCollection: state.individualSelect.keyCollection
  };
};

const mapDispatchToProps = {
  setkeyboardEnabled,
  sendShareAssets,
  editFolder,
  getRoot,
  getExplore,
  getLastUploads,
  getFavorites,
  getShared,
  cleanDataBackRoot
};

export default injectIntl(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(TagProtocolModal))
);
